<script>
    /**
     * Confirm
     */
    import ModalHeader from './ModalHeader.vue';
    import NormalButton from '../widgets/NormalButton.vue';
    import ModalFooter from './ModalFooter.vue';

    export default {
        alias: 'confirm',
        defaultOptions () {
            return {
                title: '提示',
                okDisabledCheck: null,
                cancelDisabledCheck: null
            };
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
        },
        data () {
            return {
                title: '',
                hasHTML: false,
                text: '',
                btnText: ['确定', '取消'],
                isDrag: true,
                useCancel2Close: false,
                okDisabledCheck: function () {
                    return false
                },
                cancelDisabledCheck: function () {
                    return false
                }
            };
        },
        name: 'modal-confirm',
        methods: {
            onConfirm () {
                if (this.okCallback) {
                    this.okCallback();
                }
                this.close();
            },
            onDestroy () {
                if (this.cancelCallback) {
                    this.cancelCallback();
                }
                this.close();
            },
            closeEvent () {
                if (this.useCancel2Close) {
                    this.cancelCallback && this.cancelCallback();
                } else {
                    this.closeCallback && this.closeCallback();
                }
            }
        },
        components: {
            ModalHeader,
            NormalButton,
            ModalFooter
        },
        mounted () {

        }
    };
</script>

<template>
    <div class="modal">
        <modal-header :text="title" :is-drag="true" @close="closeEvent"></modal-header>
        <div class="modal-content">
            <div class="text" v-if="hasHTML" v-html="text"></div>
            <div class="text" v-else>{{text}}</div>
        </div>
        <modal-footer>
            <normal-button @click="onConfirm();"
                           class="modal-footer-btn__center"
                           float="right"
                           :text="btnText[0] || '确定'"
                           :disabled="okDisabledCheck ? okDisabledCheck() : false"
                           theme="blue"
            ></normal-button>
            <normal-button @click="onDestroy();"
                           class="modal-footer-btn__center"
                           float="right"
                           :margin-right="2"
                           :disabled="cancelDisabledCheck ? cancelDisabledCheck() : false"
                           :text="btnText[1] || '取消'"
                           theme="grey"
            ></normal-button>
        </modal-footer>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .modal {
        .modal-style;
        max-width: 520px;
        min-height: 210px;
        height: auto;

        .text{
            word-break: break-all;
        }
    }
</style>
